// ─── Fiche INFO d'un lieu (lecture seule) ─────────────────────────
// Règle app-wide : un clic sur une ligne de liste OUVRE LA FICHE, jamais
// l'éditeur — l'édition passe par le swipe droit ou le ✏️ d'en-tête. Même
// gabarit que FicheContactInfo pour que les deux se lisent pareil.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, CarteApercu, lienItineraire, demanderItineraire, useUI, useT } from '@mop/core';

export default function FicheLieuInfo({ visible, lieu, onFermer, onEditer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const l = lieu || {};
  const coords = l.lat != null && l.lng != null ? { lat: l.lat, lng: l.lng } : null;
  const url = lienItineraire(l);
  const ouvrir = () => demanderItineraire(l, { titre: t('lieux.itineraire'), annuler: t('commun.annuler') });

  return (
    <Feuille visible={visible} titre={l.nom || t('lieux.titre')} emoji="📍" hauteur={0.8} onFermer={onFermer}
      action={{ icone: '✏️', label: t('commun.editer'), onPress: onEditer }}>
      {!!l.adresse && (
        <>
          <Text style={s.lbl}>{t('lieux.adresse')}</Text>
          {/* Un appui sur l'adresse lance l'itinéraire, comme dans la fiche
              contact — pas de gros bouton dédié. */}
          <TouchableOpacity style={s.row} activeOpacity={url ? 0.6 : 1} onPress={ouvrir} disabled={!url}>
            <Text style={{ fontSize: 17 }}>🧭</Text>
            <Text style={[s.val, url && { color: UI.accent, fontWeight: '700' }]}>{l.adresse}</Text>
          </TouchableOpacity>
          {/* Carte SOUS l'adresse : on lit d'abord ce qui est écrit, la carte
              confirme. Sans coordonnées enregistrées (cas de la plupart des
              lieux saisis à la main), CarteApercu géocode l'adresse. */}
          <CarteApercu coords={coords} adresse={l.adresse} hauteur={170} />
        </>
      )}
      {!l.adresse && <Text style={s.vide}>{t('lieux.sansAdresse')}</Text>}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  lbl: { fontSize: 12, color: UI.faint, fontWeight: '700', marginTop: 6, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.3 },
  row: { flexDirection: 'row', alignItems: 'center', gap: 11, paddingVertical: 10, borderBottomWidth: 0.5, borderBottomColor: UI.border },
  val: { flex: 1, fontSize: 14.5, color: UI.ink },
  vide: { fontSize: 13.5, color: UI.muted, marginTop: 8 },
});
